document.addEventListener("DOMContentLoaded", () => {
  const collapsedDescriptionBlock = document.querySelector(".custom-collapsed-text__description");
  const collapsedDescriptionBlockBlur = document.querySelector(".custom-collapsed-text__description-blur");
  const readMoreBtn = document.querySelector(".custom-collapsed-text__less-more-btn.read-more");
  const readLessBtn = document.querySelector(".custom-collapsed-text__less-more-btn.read-less");

  if (!collapsedDescriptionBlock) return;

  const initialHeight = collapsedDescriptionBlock.dataset.height || 210;
  const fullHeight = collapsedDescriptionBlock.scrollHeight;

  readMoreBtn.addEventListener("click", () => {
    readMoreBtn.classList.remove("active");
    readLessBtn.classList.add("active");
    collapsedDescriptionBlock.style.height = fullHeight + "px";
    collapsedDescriptionBlockBlur.style.opacity = "0";
  });

  readLessBtn.addEventListener("click", () => {
    readMoreBtn.classList.add("active");
    readLessBtn.classList.remove("active");
    collapsedDescriptionBlock.style.height = initialHeight + "px";
    collapsedDescriptionBlockBlur.style.opacity = "1";
  });
});
